<template>
    <div class="video-post" v-if="itemReady" style="position:relative;height:100%;">
        <div class="video" v-if="activeVideo">
            <!--<youtube class="miyoutube" :video-id="videoId" player-width="100%" player-height="100%"></youtube>-->
            <!--<span class="duration">03:45</span>
            <button class="video-button secondary">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>  
                </span>
            </button>-->
            <video-player class="vjs-custom-skin" 
                :options="playerOptions"
            >
            </video-player>

            <!--<iframe src="http://www.youtube.com/embed/xjS6SftYQaQ" width="100%" height="100%" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>-->
        </div>

        <div class="video touchpad video_special" :style="{'background-image': 'url('+imagen+')'}"  @click="playVideo" v-else>        
            <button class="button video-button secondary touchpad tooltip tooltip-bottom" data-tooltip="ver en Youtube">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>  
                </span>
            </button>
        </div>

        <div class="info-video" style="background:#fff;height:100px;" >
            <div class="button noBackground noPadding noMargin  ytIcon tooltip" data-tooltip="Ver en Youtube">
                <img v-if="config.new" src="/assets/img/youtube.png" alt="Icon"  width="20px" height="18px" >
                <svg v-else
                aria-hidden="true"
                focusable="false"
                data-prefix="fab"
                data-icon="youtube"
                class="svg-inline--fa fa-youtube fa-w-18"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                >
                <path
                    fill="currentColor"
                    d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                />
                </svg>
            </div>
            
        <p class="video-type noBackground noPadding noMargin" >
            {{youconfig.noticiero_nombre.length>10? youconfig.noticiero_nombre.slice(0,10)+'...':youconfig.noticiero_nombre}}
        </p>
        <h4 :class="{'video-title hora-r blink': config.new ,'video-title': !config.new }">{{youconfig.titulo}}</h4>
    </div>
    <div class="card-actions">
      <div class="video-post-footer">
        <div class="row no-gutters">
          <div class="col-11">
            <span class>{{fecha}}</span>
          </div>
          <div class="col-1 button small noMargin noBackground linkArrow tooltip tooltip-top" data-tooltip="Ver más">
            <font-awesome-icon icon="arrow-right" @click="goToNote" />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="video-post-footer">{{fecha}}</div>-->
        <!--<div class="actions">
            <button class="video-action">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-thumbs-up"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>                                            
                <span>10K</span> 
            </button>
            <button class="video-action">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-thumbs-down"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path></svg>
                <span>728</span>
            </button>
        </div>-->
    </div>
</template>


<script>
import moment from "moment-timezone";
import { getIdFromURL, getTimeFromURL } from "vue-youtube-embed";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faLink, faArrowRight } from "@fortawesome/free-solid-svg-icons";

library.add(faLink);
library.add(faArrowRight);

require("videojs-youtube/dist/Youtube");

export default {
    name: "youtubeNote",
    props: ["config", "emptyItem", "from", "subparams"],
    //components:{},
    data() {
        return {
            url: this.$store.getters.getMainUrl,
            videoId: "",
            fecha: "",
            youconfig: {},
            itemReady: false,
            playerOptions: {
            // videojs and plugin options
                height: "100%",
                sources: [{
                    type: "video/youtube",
                    src: "" // "https://d8.bdtr.net/hls/notas.m3u8?c=DF_MEX-T4-20190308-2917-50718-179" //  this.playerOptions.sources[0].src = this.streams.hls
                }],
                techOrder: ["youtube"],
                autoplay: true,
                responsive: true
            },
            activeVideo: false,
            imagen: ""
        };
    },
    computed:{
        token(){
            return this.$store.getters.getToken;
        }
    },
    mounted(){ 
       if(this.from == "public")
            this.setConfig(this.config);
        else
            this.getItem();
    },
    methods:{
        setConfig(miconfig=null){
            this.youconfig = miconfig==null? this.config: miconfig
            //console.log(this.youconfig)
            var id_arr = this.youconfig.media.split('?');
            //console.log(id_arr)
            var id_arr2 = id_arr[1].split('=');
            var id = id_arr2[1]
            //console.log(id)
            this.imagen = "https://img.youtube.com/vi/"+id+"/default.jpg";

            this.playerOptions.sources[0].src = this.youconfig.media;
            moment.tz.setDefault('America/Mexico_City');
            this.videoId = this.$youtube.getIdFromURL(this.youconfig.media)
            var  tmp =  moment(this.youconfig.publicado_utc);
            
            this.fecha  = moment.tz(tmp,'America/Mexico_City').format('DD/MM/YYYY HH:mm:ss');
            if (this.youconfig.metadatos) {
                var new_item = this.youconfig.metadatos;
        
                this.youconfig.titulo = new_item.titulo ? new_item.titulo : this.youconfig.titulo;
                
                /*this.noStars = new_item.rate ? new_item.rate : this.noStars;
                this.like = new_item.lke == true ? true : false;
                this.dislike = new_item.lke == false ? true : false;*/
            }
            
            this.itemReady=true;
        },
        getItem(){
            if(this.from == 'public'){
                this.getPublicItem();
            }else{
                this.getNormalItem();
            }
        },
        getNormalItem(){
            var post_data = {
                token:this.token,
                key: this.config.noteKey?this.config.noteKey:this.config.key,
                entrada: this.config.entrada
            }
            var self = this;
            axios.post(this.url+'getNote', JSON.stringify(post_data)) //petición
            .then((response)=>{
                if(response.data.success){
                   self.setConfig(response.data.data)
                }
                
            })
            .catch(function (error) {
                var response = {success:false,error:error}
                console.log(error);
            });
        },
        getPublicItem(){
            var obj = {
                key: this.config.noteKey,
                table: this.config.noteTable,
                subparams : this.subparams
            }
   
            var encrypted = this.$CryptoJS.AES.encrypt(JSON.stringify(obj),'secret 1576508387911');   
            var post_data = {params:encodeURIComponent(encrypted)};
            var self = this;
            axios.post(this.url+'getPublicNote', JSON.stringify(post_data)) //petición
            .then((response)=>{
                if(response.data.success){
                   self.setConfig(response.data.data)
                }
                
            })
            .catch(function (error) {
                var response = {success:false,error:error}
                console.log(error);
            });
        },
        /*goToNote(){
            var id = this.youconfig.key;
            var fi = this.youconfig.entrada?this.youconfig.entrada:this.youconfig.medio;
            this.$emit('goToNote',{id:id,fi:fi,config:this.config})
        },*/
        goToNote() {
            var miconfig = Object.assign(this.config, this.youconfig);
            this.$emit('goToNote',miconfig);
        },
        goToNotes() {
            this.$emit("goToNotes", this.youconfig);
        },
        playVideo() {
            this.activeVideo = true;
        }   
    }
};
</script>
<style scoped>
@keyframes blink {
    0% {
        color: rgb(0, 0, 0);
    }
    50% {
        color: #3fe6cd;
    }
    100% {
        color: #00b99e;
    }
}

.blink {
    
    animation: blink 2s infinite;
}
.hora-r {
    /* Estilos para cuando item.entrada es 'R' 
    color: #00b99e;*/
}
</style>
<style scoped>

.video .miyoutube {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.html5-video-player {
    /*background: transparent!important;*/
    border-radius: 15px 15px 0 0 !important;
}

.ytIcon {
  color: #ff0000;
  display: inline-block;
  margin-right: 5px;
}

.ytIcon svg {
  color: #ff0000;
}

.video-post .info-video .video-type {
  display: inline-block;
}

.textPanel-footer {
  font-size: 12px;
  font-family: "Rubik", sans-serif;
  padding: 0px 0px 5px 0px;
  margin-left: 10px;
}

.pNotas .card-actions {
  position: absolute;
  bottom: 0px;
  width: 100%;
}

.linkArrow {
  text-align: right;
  padding: 0px 5px 0px 0px;
  cursor: pointer;
}
.linkArrow:hover{
  color:#00b99e;
}
</style>